import { useEffect, useState } from "react";
import { BookOpen, Loader2, MonitorPlay } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { btnGold, errMsg, inp, lbl } from "@/components/attendance/ui";
import { bibleSlides } from "./content";

export default function BiblePanel({ onPresent }) {
  const [books, setBooks] = useState([]);
  const [ref, setRef] = useState("");
  const [pick, setPick] = useState({ book: "JOH", chapter: 3, from: "", to: "" });
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/worship/bible/books").then((r) => setBooks(r.data.books)).catch(() => {}); }, []);
  const book = books.find((b) => b.code === pick.book);

  const lookup = async (r) => {
    if (!r.trim()) return;
    setBusy(true);
    try { const x = await api.get("/worship/bible/passage", { params: { ref: r } }); setP(x.data); setRef(x.data.reference); }
    catch (e) { toast.error(errMsg(e, "Passage not found")); } finally { setBusy(false); }
  };
  const fromPicker = () => {
    const b = book?.name || "John";
    lookup(`${b} ${pick.chapter}${pick.from ? `:${pick.from}${pick.to ? `-${pick.to}` : ""}` : ""}`);
  };
  const show = () => onPresent({ title: p.reference, label: `${p.reference} · ${p.translation.code}`, slides: bibleSlides(p), desc: { type: "bible", ref: p.reference, label: p.reference } });

  return (
    <div className="space-y-3" data-testid="bible-panel">
      <form onSubmit={(e) => { e.preventDefault(); lookup(ref); }} className="flex gap-2">
        <input className={inp} value={ref} onChange={(e) => setRef(e.target.value)} placeholder="John 3:16, Psalm 23, Romans 8:28-30" data-testid="bible-ref" />
        <button className={btnGold} data-testid="bible-go">{busy ? <Loader2 size={14} className="animate-spin" /> : <BookOpen size={14} />}</button>
      </form>
      <div className="grid grid-cols-4 gap-2">
        <div className="col-span-4"><label className={lbl}>Book</label>
          <select className={inp} value={pick.book} onChange={(e) => setPick({ ...pick, book: e.target.value, chapter: 1 })} data-testid="bible-book">{books.map((b) => <option key={b.code} value={b.code}>{b.name}</option>)}</select></div>
        <div><label className={lbl}>Ch.</label><input type="number" min="1" max={book?.chapters || 150} className={inp} value={pick.chapter} onChange={(e) => setPick({ ...pick, chapter: e.target.value })} data-testid="bible-chapter" /></div>
        <div><label className={lbl}>From</label><input type="number" min="1" className={inp} value={pick.from} onChange={(e) => setPick({ ...pick, from: e.target.value })} data-testid="bible-from" /></div>
        <div><label className={lbl}>To</label><input type="number" min="1" className={inp} value={pick.to} onChange={(e) => setPick({ ...pick, to: e.target.value })} data-testid="bible-to" /></div>
        <button onClick={fromPicker} type="button" className="self-end py-2.5 rounded border border-white/15 text-xs text-neutral-200 hover:border-[#D4AF37]" data-testid="bible-pick-go">Find</button>
      </div>
      {p && (
        <div className="space-y-2" data-testid="bible-preview">
          <div className="flex items-center justify-between gap-2">
            <div className="text-sm text-white" data-testid="bible-preview-ref">{p.reference} <span className="text-[10px] text-neutral-500">{p.translation.name}</span></div>
            <button onClick={show} className={btnGold} data-testid="bible-present"><MonitorPlay size={14} /> Show</button>
          </div>
          <div className="hymn-protect max-h-[38vh] overflow-y-auto text-xs text-neutral-300 space-y-1 pr-1">
            {p.verses.map((v) => <p key={`${v.c}:${v.v}`}><span className="text-[#D4AF37] mr-1">{v.v}</span>{v.text}</p>)}
          </div>
          <p className="text-[10px] text-neutral-600">{bibleSlides(p).length} slides · long passages are split automatically</p>
        </div>
      )}
    </div>
  );
}
